import _ from 'lodash'
import { MeshItemData, MeshItemLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types'

interface XYLayout {
	x: number
	y: number
	width: number
	height: number
	rotate?: number
}

// @ts-ignore
function degreesToRadians(angleInDegrees) {
	return (angleInDegrees * Math.PI) / 180
}

// @ts-ignore
const getBoundingWidthWithRotation = (layout, angleInRadians) =>
	Math.abs(layout.width * Math.cos(angleInRadians)) + Math.abs(layout.height * Math.sin(angleInRadians))
// @ts-ignore
const getBoundingHeightWithRotation = (layout, angleInRadians) =>
	Math.abs(layout.width * Math.sin(angleInRadians)) + Math.abs(layout.height * Math.cos(angleInRadians))
// @ts-ignore
const getXAfterRotation = (layout, rotatedWidth) => layout.x - (rotatedWidth - layout.width) / 2
// @ts-ignore
const getYAfterRotation = (layout, rotatedHeight) => layout.y - (rotatedHeight - layout.height) / 2

function rotateAndGetBoundingLayout(layout: XYLayout) {
	if (layout.rotate === 0) {
		return _.pick(layout, ['x', 'y', 'width', 'height'])
	}

	const angleInRadians = degreesToRadians(layout.rotate)
	const boundingWidth = getBoundingWidthWithRotation(layout, angleInRadians)
	const boundingHeight = getBoundingHeightWithRotation(layout, angleInRadians)
	return {
		x: Math.floor(getXAfterRotation(layout, boundingWidth)),
		y: Math.floor(getYAfterRotation(layout, boundingHeight)),
		width: Math.ceil(boundingWidth),
		height: Math.ceil(boundingHeight),
	}
}

function getBoundingLayout(layout: XYLayout) {
	return rotateAndGetBoundingLayout(layout)
}

export const getComponentBoundingBox = (singleLayout: SingleLayoutData, rotate: number): MeshItemData => {
	const itemLayout: MeshItemLayout = singleLayout.itemLayout as MeshItemLayout
	return getBoundingLayout({ ...itemLayout.meshData, rotate })
}
